import apiListaClientes from '@api/listaClientes'

/**
 * O cliente da lista pelo id, comparado por String: o id da rota vem de
 * `$route.params` (sempre string) e o da store é number — `124584 === '124584'`
 * é `false`, e o `find` estrito nunca achava ninguém (G-1 da spec-009).
 */
export function clienteDaListaPorId(clientes, id) {
  if (!id) return null
  return (clientes || []).find((c) => c && String(c.id) === String(id)) || null
}

/**
 * Resolve um cliente pelo id em três tentativas, na ordem: a lista já na store
 * (`user/allClients`), a lista buscada (store fria) e o universo com inativos —
 * `user/allClients` é carregada sem a flag e nunca traz um inativo. Ao achar
 * um inativo, merge pontual por `user/upsertCliente` (nunca `setClients`, que
 * substituiria a store inteira). `null` quando não há cliente ou acesso.
 *
 * Fonte única do perfil do cliente (`client-profile.vue`) e da carteira
 * (`minha-carteira.vue`); cada tela decide o que fazer com o resultado.
 *
 *   const cliente = await resolverClientePorId(this.$store, this.routeId)
 */
export async function resolverClientePorId(store, id) {
  if (!id) return null

  const daStore = clienteDaListaPorId(store.getters['user/allClients'], id)
  if (daStore) return daStore

  await apiListaClientes.carregar()
  const daBusca = clienteDaListaPorId(store.getters['user/allClients'], id)
  if (daBusca) return daBusca

  const todos = await apiListaClientes.carregar({ includeInactive: true })
  const inativo = clienteDaListaPorId(todos, id)
  if (inativo) store.dispatch('user/upsertCliente', inativo)
  return inativo
}
